$(document).ready(customProduct);
document.addEventListener("ShoptetDOMPageContentLoaded", customProduct);
document.addEventListener("ShoptetPageSortingChanged", customProduct);
document.addEventListener("ShoptetDOMPageMoreProductsLoaded", customProduct);
document.addEventListener("ShoptetDOMContentLoaded", customProduct);

function customProduct() {
    $(".product").each(function () {
        const $product = $(this);

        if ($product.find(".p-tools form").length) {
            if (!$product.find(".quantity").length) {
                $product.find(".p-tools form").prepend($quantity);
            }
        } else {
            $product.find(".p-tools a").text("Detail produktu");
        }

    });
}

var $quantity = `
    <span class="quantity">
        <span class="increase-tooltip js-increase-tooltip" data-trigger="manual" data-container="body" data-original-title="tooltipMax" aria-hidden="true" role="tooltip" data-testid="tooltip"></span>
        <span class="decrease-tooltip js-decrease-tooltip" data-trigger="manual" data-container="body" data-original-title="tooltipMin" aria-hidden="true" role="tooltip" data-testid="tooltip"></span>
        <label>
            <input type="number" name="amount" value="1" class="amount" autocomplete="off" data-decimals="0" step="1" min="1" max="9999" aria-label="Množství" data-testid="cartAmount">
        </label>
        <button class="increase" type="button" aria-label="Zvýšit množství o 1" data-testid="increase">
            <span class="increase__sign">+</span>
        </button>
        <button class="decrease" type="button" aria-label="Snížit množství o 1" data-testid="decrease">
            <span class="decrease__sign">−</span>
        </button>
    </span>
`;

function applyProductsQuantityData() {
    (window.losicaProducts || []).forEach(function (product) {
        const decimalCount = product.decimalCount;
        const minimumAmount = product.minimumAmount;

        if (!minimumAmount) {
            return;
        }

        $('[data-micro="sku"]').filter(function () {
            return $.trim($(this).text()) === String(product.code);
        }).each(function () {
            const $input = $(this).closest(".product, .type-detail").find(".quantity input").first();

            if (!$input.length) {
                return;
            }

            const origStep = $input.attr('step') || '';
            const origDataMin = $input.attr('data-min') || '';

            $input
                .addClass('amount multiple-check')
                .val(minimumAmount)
                .attr('value', minimumAmount)
                .attr('data-decimals', decimalCount)
                .attr('data-orig-step', origStep)
                .attr('data-orig-datamin', origDataMin)
                .attr('step', minimumAmount)
                .attr('min', minimumAmount)
                .attr('data-min', minimumAmount);
        });
    });
}

$("html").on("click", ".products .product button.add-to-cart-button", function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var inputVal = $(this).closest(".p-tools").find("input").val();
    var inputPriceId = $(this).closest(".p-tools").find('input[name="priceId"]').attr("value");
    shoptet.cartShared.addToCart({ priceId: inputPriceId, amount: inputVal });
});



